import { YStack, XStack, Text, View } from "tamagui";
import { RiStore2Line } from "react-icons/ri";
import { colors } from "@styles/colors";
import StepLayout from "../StepLayout";
import { PrimaryBtn, SecondaryBtn } from "../Buttons";
import type { AddressData, Supplier } from "../types";

interface ConfirmMappingStepProps {
  supplier: Supplier;
  address: AddressData | null;
  onConfirm: (s: Supplier) => void;
  onReject: () => void;
  onBack: () => void;
}

/** 步驟 3a：手機配對命中 → 確認是否為此瓦斯行的客戶。 */
const ConfirmMappingStep = ({ supplier, address, onConfirm, onReject, onBack }: ConfirmMappingStepProps) => {
  return (
    <StepLayout
      title="為您找到瓦斯行"
      subtitle="請確認以下這家是否為您的瓦斯行"
      onBack={onBack}
      step={3}
      footer={
        <XStack gap="$2.5">
          <View flex={1}>
            <SecondaryBtn onPress={onReject}>不是,看其他</SecondaryBtn>
          </View>
          <View flex={1.5}>
            <PrimaryBtn onPress={() => onConfirm(supplier)}>是,綁定此瓦斯行</PrimaryBtn>
          </View>
        </XStack>
      }>
      <YStack gap={14}>
        {/* 瓦斯行卡片 */}
        <YStack
          background={colors.primaryBg}
          borderRadius={18}
          p="$4"
          borderWidth={1.5}
          borderColor="#BFDBFE">
          <XStack ai="center" gap="$3" mb="$3">
            <View
              width={56}
              height={56}
              borderRadius={14}
              ai="center"
              jc="center"
              className="primary-bg-gradient">
              <RiStore2Line size={26} color={colors.light} />
            </View>
            <YStack flex={1}>
              <Text fontSize={11} color={colors.primary} fontWeight="700" letterSpacing={1} mb="$1">
                ✨ 您的瓦斯行
              </Text>
              <Text fontSize={20} fontWeight="800" color={colors.primaryText}>
                {supplier.company}
              </Text>
              <Text fontSize={12} color={colors.sub} mt="$0.5">
                {supplier.area}
              </Text>
            </YStack>
          </XStack>

          {address?.address && (
            <XStack background="rgba(255,255,255,0.7)" borderRadius={12} p="$2.5" ai="center" gap="$2">
              <Text fontSize={14}>📍</Text>
              <Text fontSize={12} color={colors.sub} flex={1} lineHeight={18}>
                {address.address}
              </Text>
            </XStack>
          )}
        </YStack>

        {/* 提示 */}
        <XStack background={colors.bgGreen} borderRadius={14} p="$3.5" gap="$3" ai="flex-start" borderWidth={1} borderColor="#BBF7D0">
          <Text fontSize={18}>💡</Text>
          <YStack flex={1}>
            <Text fontSize={13} color={colors.greenText} fontWeight="700" mb="$1">
              請問您是 {supplier.company} 的客戶嗎?
            </Text>
            <Text fontSize={12} color={colors.green} lineHeight={18}>
              確認後,即可使用本平台叫瓦斯,並完成線上簽約
            </Text>
          </YStack>
        </XStack>
      </YStack>
    </StepLayout>
  );
};

export default ConfirmMappingStep;
